import MuiLink from "@mui/material/Link";
const Link = MuiLink;
export default Link;
